import { render } from "./FraudexFeedbackPopup.vue?vue&type=template&id=586ccbc3&ts=true"
import script from "./FraudexFeedbackPopup.vue?vue&type=script&lang=ts"
export * from "./FraudexFeedbackPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__